export function parseHtml(text) {
  if (!text) return
  const lines = text.split(/\r|\n/)
  return lines
    .map(line => {
      if (line.includes('==='))
        return `<h1> ${line.replace('===', '').replace('===', '')} </h1>`
      else if (line === '')
        return '<hr style="height:.001px; visibility:hidden;" />'
      else if (line.includes('<')) {
        const link = line.replace('<', '').replace('/>', '')
        return `<a href="${link}" target="_blank">Research Link</a>`
      } else return line
    })
    .join('')
}
